import React from 'react';
import cn from 'classnames';
import styles from './Caption.less';

type CaptionProps = {
  children: React.ReactNode;

  /** Sets custom css classes */
  className?: string;
};

const Caption: React.SFC<CaptionProps> = ({ children, className }: CaptionProps): JSX.Element => (
  <div className={cn(styles.caption, className)}>{children}</div>
);

export default Caption;
